import { IMOVEL_GET, IMOVEL_LIST, IMOVEL_INNER_LIST, FICHA_CADASTRAL_GET, RESET } from '../actions/Events';

export default function (state = {}, action) {
  switch (action.type) {
    case IMOVEL_LIST:
      return { ...state, results: action.payload }

    case IMOVEL_INNER_LIST:
      return { ...state, innerResults: action.payload }

    case IMOVEL_GET:
      return { ...state, current: action.payload }

    case FICHA_CADASTRAL_GET:
      return { ...state, currentFicha: action.payload }

    case RESET:
      return {}

    default:
      return state
  }
}

